import $ from 'jquery'

import sanitizer from '@app/adapters/sanitizer'

$(document).on('hidden', '[data-behavior~="adjustment_form"]', function () {
  setTimeout(() => $(this).remove(), 500)
})

onDomLoad(function ($dom) {
  let timeoutRef = null

  $dom
    .find('table#adjustments')
    .find(`tr[data-anchor='${document.location.hash.substr(1)}']`)
    .addClass('in-focus')

  if ($dom.find('[data-behavior~="adjustment_form"]').length > 0) {
    setupSelect2($dom)
    markLastRow()

    $dom.on('focus', '.sub-adjustment-table-row .select2', function (e) {
      if (e.originalEvent) {
        return $(this).siblings('select').select2('open')
      }
    })

    timeoutRef = setTimeout(function () {
      const $firstElement = $(document)
        .find('.sub-adjustment-table-row .select2')
        .first()
        .siblings('select')

      const value = $firstElement.val()

      if (value?.length === 0) {
        $firstElement.select2('open')
      }
    }, 500)

    $dom.one('turbolinks:before-visit', () => {
      clearTimeout(timeoutRef)
      $dom.off('focus', '.sub-adjustment-table-row .select2')
    })
  }
})

const setupSelect2 = (dom) => {
  $(dom)
    .find('[data-behaviour~="simple-select2"]')
    .each((i, el) => {
      const minimumInputLength = el.dataset.select2MinimumInputLength || 2
      const dropdownCssClass = el.dataset.select2DropdownCssClass || ''

      $(el).select2({
        minimumInputLength: minimumInputLength,
        dropdownCssClass: dropdownCssClass,
      })
    })

  $(dom)
    .find('[data-behavior="account-select2"]')
    .select2({
      selectOnClose: true,
      placeholder: '',
      allowClear: true,
      minimumInputLength: 1,
      width: '100%',
      theme: 'silverfin',
      dropdownCssClass: 'accounts-dropdown',
      escapeMarkup(markup) {
        return sanitizer(markup)
      },
      templateResult(item) {
        if (item.children) {
          // it's a section
          return item.text
        } else {
          // it's an account
          return item.formatted_text
        }
      },
      templateSelection(account) {
        return account.id
      },
      ajax: {
        url: `/f/${$('#current_firm_id').val()}/${$(
          '#current_company_id'
        ).val()}/accounts/autocomplete`,
        dataType: 'json',
        data(params) {
          return {
            q: params.term,
            ledger_id: $('[data-behavior~="adjustment_form"] form').data(
              'ledger_id'
            ),
          }
        },
        processResults(data) {
          const newData = $.map(data, window.formatAccountsForSelect2)
          return { results: newData }
        },
      },
    })
    .on('select2:select', function (event) {
      const { data } = event.params
      $(this).attr('data-value-left', data.actual_value)
      $(this).attr('data-account-number', data.value)
      const parent = $(this).closest('tr')
      parent.find('.account-value-left').attr('data-account-number', data.value)
      parent
        .find('[data-behavior~="values-debit"]')
        .attr('data-account-number', data.value)
      parent
        .find('[data-behavior~="values-credit"]')
        .attr('data-account-number', data.value)

      parent.find('[data-behavior~="account-name"]').val(data.name).focus()

      parent
        .find('[data-behavior~="account-original-name"]')
        .text(data.original_name || '')
      parent
        .find('[data-behavior~="account-original-number"]')
        .text(data.original_number || '')

      if (accountNumberHasCostCenter(data.value)) {
        parent.find('[data-behavior~="analytic-input"]').prop('disabled', false)
        parent
          .find('[data-behavior~="analytic-input"] option')
          .prop('disabled', false)
      } else {
        parent.find('[data-behavior~="analytic-input"]').prop('disabled', true)
        parent.find('[data-behavior~="analytic-input"]').val('')
      }

      $($(this).attr('data-account-id')).val(data.id)

      updateValueLeft($(this).parents('form'), data.value)
      return data.value
    })
    .on('select2:unselect', function () {
      const parent = $(this).closest('tr')
      parent.find('[data-behavior~="account-original-name"]').text('')
      parent.find('[data-behavior~="account-original-number"]').text('')
    })
}

const updateValueLeft = function (form, accountNumber) {
  let newValueLeft = parseFloat(
    $(form)
      .find(
        `select[data-behavior~="account-select2"][data-account-number="${accountNumber}"]`
      )
      .attr('data-value-left')
  )

  $(form)
    .find(
      `input[data-behavior~="values-debit"][data-account-number="${accountNumber}"]`
    )
    .each(function () {
      const parsedValue = parseFloat(this.value.replace(',', '.'))
      if (parsedValue) {
        return (newValueLeft += parsedValue)
      }
    })

  $(form)
    .find(
      `input[data-behavior~="values-credit"][data-account-number="${accountNumber}"]`
    )
    .each(function () {
      const parsedValue = parseFloat(this.value.replace(',', '.'))
      if (parsedValue) {
        return (newValueLeft -= parsedValue)
      }
    })

  return $(form)
    .find(`.account-value-left[data-account-number="${accountNumber}"]`)
    .each(function () {
      return $(this).html(
        $.formatNumber(newValueLeft, {
          format: '#,##0.00',
          locale: Silverfin.currentUserLocale(),
        })
      )
    })
}

const updateAllValuesLeft = (element) =>
  $(element)
    .find('[data-behavior~="adjustment_form"]')
    .each(function () {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const form = this
      return $(this)
        .find('[data-value-left]')
        .each(function () {
          return updateValueLeft($(form), $(this).attr('data-account-number'))
        })
    })

$(document).on('turbolinks:load', () => updateAllValuesLeft('body'))

const accountNumberHasCostCenter = function (number) {
  const startingNumber = `${number}`[0]
  return startingNumber === '6' || startingNumber === '7'
}

$(document).on('blur', '[data-behavior~="adjustment_form"]', function () {
  let debitTotal = 0
  let creditTotal = 0
  $(this)
    .find('[data-behavior~="values-debit"]')
    .each(function () {
      const value = $(this).val().replace(',', '.')
      if (!isNaN(value) && value.length !== 0) {
        return (debitTotal += parseFloat(value))
      }
    })
  $(this)
    .find('[data-behavior~="values-credit"]')
    .each(function () {
      const value = $(this).val().replace(',', '.')
      if (!isNaN(value) && value.length !== 0) {
        return (creditTotal += parseFloat(value))
      }
    })

  $(this)
    .find('[data-behavior~="debit-total"]')
    .html(
      $.formatNumber(debitTotal, {
        format: '#,##0.00',
        locale: Silverfin.currentUserLocale(),
      })
    )
  $(this)
    .find('[data-behavior~="credit-total"]')
    .html(
      $.formatNumber(creditTotal, {
        format: '#,##0.00',
        locale: Silverfin.currentUserLocale(),
      })
    )
  $(this)
    .find('[data-behavior~="credit-difference"]')
    .html(
      $.formatNumber(debitTotal - creditTotal, {
        format: '#,##0.00',
        locale: Silverfin.currentUserLocale(),
      })
    )
  $(this)
    .find('[data-behavior~="debit-difference"]')
    .html(
      $.formatNumber(creditTotal - debitTotal, {
        format: '#,##0.00',
        locale: Silverfin.currentUserLocale(),
      })
    )
})

$(document).on(
  'cocoon:after-insert',
  '[data-behavior~="adjustment_form"]',
  function (event, insertedItem) {
    setupSelect2(insertedItem)
    markLastRow()
  }
)

$(document).on(
  'keyup focus',
  '[data-behavior~="adjustment_form"] tr.sub-adjustment-table-row',
  function () {
    // if it has an account number, update in realtime the account value left
    const accountNumber = $(this)
      .find('select[data-behavior~="account-select2"]')
      .attr('data-account-number')
    if (accountNumber) {
      updateValueLeft($(this).closest('form'), accountNumber)
    }

    // add an extra field when text is entered in the bottom row
    if (!$(this).next().hasClass('sub-adjustment-table-row')) {
      $(this)
        .closest('form')
        .find('[data-behavior~="add_sub_adjustment_link"]')
        .click()
    }

    // copy from previous when the field is empty
    if ($(this).find('[data-behavior~="copy-from-previous"]').val() === '') {
      if (
        $(this).prev().find('[data-behavior~="copy-from-previous"]').length > 0
      ) {
        $(this)
          .find('[data-behavior~="copy-from-previous"]')
          .val(
            $(this).prev().find('[data-behavior~="copy-from-previous"]').val()
          )
      }
    }
  }
)

const markLastRow = () =>
  $('.sub-adjustment-table-row')
    .removeClass('sub-adjustment-table-row--last')
    .last()
    .addClass('sub-adjustment-table-row--last')

$(document).on(
  'click',
  '[data-behavior="remove-sub-adjustment-row"]',
  function (event) {
    event.preventDefault()
    $(event.currentTarget).closest('.sub-adjustment-table-row').remove()
  }
)
